import React, { useEffect, useState } from "react";
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle,IconButton, Paper, Table,TableBody,TableCell,TableContainer,TableHead,TableRow, TextField, Typography,} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import axios from "axios";
import { Edit } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const ManageCategories = (user) => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const [openDialog, setOpenDialog] = useState(false);
  const [newCategoryName, setNewCategoryName] = useState("");
  const [newCategoryImage, setNewCategoryImage] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [formError, setFormError] = useState('');
  const [editMode, setEditMode] = useState(false);
  const [editingCategoryId, setEditingCategoryId] = useState(null);

  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/categoriesWithImages`);
      setCategories(response.data);
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      setLoading(false);
    }
  };
  const [isLoggedIn, setIsLoggedIn] = useState(false);
   const [username, setUsername] = useState('');
    const [userType, setuserType] = useState('');

   const navigate = useNavigate();
  
  async function getUsernamefromCookie() {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/isLoggedIn`, { withCredentials: true }); 
      if (response.data.username ) {
        setUsername(response.data.username);
        setuserType(response.data.user);
        setIsLoggedIn(true);
      } else {
        setIsLoggedIn(false);
        navigate('/login'); 
      }
    } catch (error) {
      console.error('Error fetching login status:', error);
      navigate('/login'); 
    }
  }

  useEffect(() => {
    fetchCategories();
    getUsernamefromCookie();
  }, []);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setNewCategoryImage(file);
  };

  const handleDialogClose = () => {
  setOpenDialog(false);
  setNewCategoryName("");
  setNewCategoryImage(null);
  setFormError('');
  setEditMode(false);
  setEditingCategoryId(null);
};

  const handleEditCategory = (category) => {
      setNewCategoryName(category.name);
      setEditingCategoryId(category._id);
      setEditMode(true);
      setOpenDialog(true);
    };

  const handleSaveCategory = async () => {
  if (!newCategoryName) return;

  try {
    setUploading(true);

    const formData = new FormData();
    let imageUrl="";
    formData.append("category", newCategoryName);
    if (newCategoryImage) formData.append("image", newCategoryImage);

    if (editMode) {
      formData.append("lastEditedBy",username);
      formData.append("id",editingCategoryId);
      await axios.put(`${API_BASE_URL}/api/updateCategory`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
    } else {
      formData.append("createdBy",username);
      const existsRes = await axios.post(`${API_BASE_URL}/api/checkCategory`, { name: newCategoryName });

      if (existsRes.data.exists) {
        setFormError(existsRes.data.message);
        return;
      }
      if(newCategoryImage)
      {
      const imageUploadRes = await axios.post(`${API_BASE_URL}/api/upload-image-category`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
       imageUrl = imageUploadRes.data.imageUrl;
      }
      await axios.post(`${API_BASE_URL}/api/createCategory`, {
        name: newCategoryName,
        eventImage: imageUrl,
        createdBy:username
      });
    }
    handleDialogClose();
    fetchCategories();
  } catch (error) {
    setFormError(error?.response?.data?.message || "Something went wrong");
  } finally {
    setUploading(false);
  }
};

  return (
    <Box p={3}>
      <Typography variant="h4" gutterBottom>
        Manage Tags
      </Typography>
      { userType === 'Admin'?
      <Button variant="contained" color="primary" startIcon={<AddIcon />}  onClick={() => setOpenDialog(true)} sx={{ mb: 2 }}> Add Tag</Button> :<></>
      }
      {loading ? (
        <CircularProgress />
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell><strong>Tag Name</strong></TableCell>
                <TableCell><strong>Image</strong></TableCell>
                <TableCell><strong></strong></TableCell>

              </TableRow>
            </TableHead>
            <TableBody>
              {categories.map((cat) => (
                <TableRow key={cat._id}>
                  <TableCell>{cat.name}</TableCell>
                  <TableCell>
                    {cat.eventImage ? (
                      <img
                        src={cat.eventImage}
                        alt={cat.name}
                        width={80}
                        height={60}
                        style={{ objectFit: "cover", borderRadius: "4px" }}
                      />
                    ) : (
                      "No image"
                    )}
                  </TableCell>
                  <TableCell>
                <IconButton onClick={() => handleEditCategory(cat)}>
                  <Edit />
                </IconButton>
              </TableCell>

              

                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      <Dialog open={openDialog} onClose={handleDialogClose} fullWidth maxWidth="sm" PaperProps={{ sx: {   width: '90%',  maxWidth: '500px'   } }}>
        <DialogTitle>Add New Tag</DialogTitle>
        <DialogContent dividers>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {formError && (
                          <Typography color="error" sx={{ mt: 1, textAlign: 'center' }}>
                            {formError}
                          </Typography>
             )}
          <TextField
            fullWidth
            label="Tag Name"
            value={newCategoryName}
            onChange={(e) => setNewCategoryName(e.target.value)}
            style={{ width: "40%", maxWidth: "100%",  alignSelf: "center" }}
          />
          <input type="file" accept="image/*" onChange={handleFileChange} style={{ width: "40%", maxWidth: "100%",  alignSelf: "center"}} />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} disabled={uploading}>
            Cancel
          </Button>
          {/* <Button onClick={handleAddCategory} variant="contained" disabled={uploading}>
            {uploading ? "Uploading..." : "Save"}
          </Button> */}
              <Button onClick={handleSaveCategory} variant="contained" disabled={uploading}>
  {uploading ? "Saving..." : (editMode ? "Update" : "Save")}
</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ManageCategories;
